import { render, staticRenderFns } from "./channelTotalReport.vue?vue&type=template&id=2c6d8430&scoped=true"
import script from "./channelTotalReport.vue?vue&type=script&lang=js"
export * from "./channelTotalReport.vue?vue&type=script&lang=js"
import style0 from "./channelTotalReport.vue?vue&type=style&index=0&id=2c6d8430&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d8430",
  null
  
)

export default component.exports